<div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
  <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
    <h2 class="noMarginHeader">
      <mat-icon>bar_chart</mat-icon> Vouchers with Exceedances but not flagged
    </h2><br />
  </div>
</div>
<div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
  <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
    <small>Any Voucher that has a Sample with an Exceedance, but is not flagged on the Voucher will display on this
      report.</small><br />
  </div>
</div>

<mat-card *ngIf="loading">
  <span>Loading</span><br />
  <mat-progress-bar mode="query"></mat-progress-bar>
</mat-card>

<!-- List of Letter Tasks -->
<mat-card>
  <div [fxFlex.gt-sm]="100" [fxFlex]="100" class="matero-col" style="overflow-x: auto;">
    <br />
    <mat-table [dataSource]="dataSource" matSort #TableSort="matSort" class="mat-elevation-z8"
      style="overflow-x: auto;">
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      <ng-container matColumnDef="voucherId">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Voucher Id</mat-header-cell>
        <mat-cell *matCellDef="let result">
          <a (click)="editVoucher(result.voucherId)"
            title="Edit Voucher {{result.voucherIdentifier}}">{{result.voucherIdentifier}}</a>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="applicationType">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Type</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.applicationType}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="sampleId">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Sample ID</mat-header-cell>
        <mat-cell *matCellDef="let result">
          <a href="javascript:void(0)" (click)="editSample(result.sampleId)"
            title="Edit Sample {{result.sampleId}}">{{result.sampleId}}</a>

        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="analyte">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Analyte</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.analyte}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="result">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Result</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.result}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="unit">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Unit</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.unit}}
        </mat-cell>
      </ng-container>
    </mat-table>
    <br />
    <mat-paginator [pageSizeOptions]="[10, 20, 50]" #TablePaginator="matPaginator" showFirstLastButtons></mat-paginator>
  </div>
</mat-card>